<template>
  <div class="page-content" id="device-list">

    <Titlebar :incrustation="'fa-hashtag'">
      <h1>{{ $t('device.titles.listRegistration') }}</h1>
    </Titlebar>

    <UiDrawer v-model="isDrawerOpen" :title="$t('device.registrations.send_licences.title_drawer')">
      <span class="my-3" v-html="$tc('device.registrations.send_licences.info', sendableCount, {count: sendableCount})"></span>

      <div class="column is-8 is-offset-2 mt-4">
        <ExcelManagement v-on:reload="getRegistrations" :licences-ids="selectedItems.map(item => item.id)" />

        <div v-if="errorSQS" class="alert alert-danger" role="alert">
          <strong>{{ $t('users.errorMessages.titleTechnicalIssue') }}</strong>
          <br>
          {{  $t('users.errorMessages.technicalIssue') }}
        </div>

      </div>
    </UiDrawer>

    <UiCard>
      <div class="d-flex align-items-center gap-3 mb-4">
        <h6 class="m-0">{{ $t("device.registrations.mass_actions") }}</h6>
        <Button2
          :disabled="!sendableCount"
          @click.native.prevent="toggleDrawer"
        >
          {{ $t("device.registrations.send_licences.title") }}
          <span class="text-mono">({{ sendableCount }})</span>
        </Button2>
        <Button2
          :disabled="!cancelableCount"
          @click.native.prevent="handleCancelLicences"
        >
          {{ $t("device.registrations.cancel_licences.title") }}
          <span class="text-mono">({{ cancelableCount }})</span>
        </Button2>
        <Button2
          :disabled="!resendableCount"
          @click.native.prevent="handleResendLicences"
        >
          {{ $t("device.registrations.resend_licences.title") }}
          <span class="text-mono">({{ resendableCount }})</span>
        </Button2>
      </div>

      <div class="mb-4">
        <span v-if="!loading">{{ $tc("device.registrations.table_count", count, {count}) }}</span>
        <span v-else>&nbsp;</span>
      </div>

      <div class="position-relative">

        <div class="progress progress-table" v-if="inProgress">
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :aria-label="$t('device.registrations.progression')"
            :aria-valuenow="progressBar"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="{'width':progressBar + '%'}"
          ></div>
        </div>

        <SuperTable
          ref="tableIdentifications"
          :tableColumns="tableColumns"
          :tableData="tableData"
          :loading="loading"
          @expired="handleExpired"
          @reload="loadData"
          @qrcode="handleAssociation"
          @cancel="handleCancel"
          @send="handleSend"
          @sendfirsttime="handleSendFirstTime"
          @sort="handleSort"
          @filter="handleFilter"
          @onSelectAll="handleSelectAll"
          @onSelectRow="handleSelectItem"
          @associate="handleAssociation"
        />

      </div>

    </UiCard>
    <Toolbar>
      <div class="row">
        <div class="col" v-can="'beepiz-browseAssoc-licences'">
          <div class="toolbar-control d-flex align-items-center" @click="handleCheckDevices">
              <span>
                  <span class="checkbox rounded" :class="{check:checkDevices}" style="border-radius: 3px; margin-right: 15px">
                      <i class="fa fa-check"></i>
                  </span>
              </span>
            <span style="display: flex;align-items: center;line-height: 1;">{{ $t('device.registrations.associated') }}</span>
          </div>
        </div>
        <div class="col center">
          <Pagination ref="pagination" @change="handlePagination" />
        </div>

        <div class="col">
          <div class="float-right">
            <Btn v-can="'beepiz-browseAssoc-licences'"
                 style="margin-left: auto;"
                 :class="[{'no-hover':showActionsDL,disabled: lockDLBtn},'default']"
                 @click.native.prevent="licencesExport('xls')">
              <span><i class="fa fa-download"></i>&nbsp;&nbsp;&nbsp;{{ $t('global.download') }}</span>
              <LoadingMini ref="loading"></LoadingMini>
            </Btn>
          </div>
        </div>

      </div>
    </Toolbar>
  </div>
</template>

<script>

import Vue from 'vue'
import axios from 'axios';
import API from '@/services/API.js';
import Globals from '@/services/globals.js';
import denseModeMixin from '@/mixins/denseMode.js'
import Titlebar from "@/components/ui/Titlebar";
import Toolbar from "@/components/ui/Toolbar";
import Btn from "@/components/ui/Button";
import Button2 from "@/components/ui/Button2.vue";
import UiCard from "@/components/ui/Card";
import Pagination from "@/components/ui/Pagination";
import SuperTable from "@/components/ui/Table";
import LoadingMini from "@/components/ui/LoadingMini";
import UiDrawer from "@/components/ui/UiDrawer";
import {mixin as clickaway} from 'vue-clickaway';

import StatusRenderer from "@/components/devices/tableRenderers/StatusRenderer";
import AnalyticsRenderer from "@/components/devices/tableRenderers/AnalyticsRenderer";
import ActionsRenderer from "@/components/devices/tableRenderers/ActionsRenderer";
import SelectAllRenderer from "@/components/ui/table-renderer/SelectAllRenderer";
import SelectRowRenderer from "@/components/ui/table-renderer/SelectRowRenderer";

import InfoRenderer from "@/components/devices/tableRenderers/InfoRenderer";
import ProfileRenderer from "@/components/devices/tableRenderers/ProfileRenderer";

import ActionsLicencesModal from "@/components/devices/ActionsLicencesModal";

import Association from '@/views/devices/Association';
import Sms from '@/views/devices/Sms';

import Utils from "@/services/utils.js";

import { useDvFlagAccess } from '@/services/featureFlag';
import LicenceAssociationModal from '@/components/devices/LicenceAssociationModal.vue';

import picto_standard from '@/assets/img/picto/1_Standard_yellow.svg'
import picto_premium from '@/assets/img/picto/2_Premium_yellow.svg'
import picto_enterprise from '@/assets/img/picto/3_Enterprise_yellow.svg'

import ExcelManagement from '@/views/devices/ExcelManagement.vue'

export default {
  name: 'DevicesBulk',
  components: {
    Titlebar,
    Toolbar,
    Btn,
    Pagination,
    SuperTable,
    LoadingMini,
    ExcelManagement,
    Button2,
    UiCard,
    UiDrawer
  },

  data: () => ({
    progressBar: 0,
    inProgress: false,
    errorSQS: false,
    loading: true,
    file: null,
    userAction: 0,
    batchGroup: null,
    userSelection: 0,
    count: 0,
    forceFormDisabled: false,
    config: {
      perpage: Globals.perPage,
      fields: [],
      page: 1,
      filter: {
        like: [],
        equals: []
      },
      sort: []
    },
    showActions: false,
    phones: [],
    phonesNames: [],
    phonesAnalytic: [],
    phonesOptions: [],
    availableLicences: 0,
    analyticsInEdition: null,
    renderer: null,
    profiles: [],
    groups: [],
    bulkLicenceType: null,
    tableColumns: {
      global: {
        sortable: false,
        noItemsMsg: window.V.$i18n.t('device.registrations.emptyTable')
      },
      columns: [
        {
          key: 'action',
          label: SelectAllRenderer,
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: false,
          filter: false,
          renderer: SelectRowRenderer,
          width: '1%'
        },
        {
          key: 'key',
          label: Utils.t('device.registrations.licence'),
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: true,
          filter: {
            type: 'text'
          },
          renderer: function (item) {
            var ret = '<span class="licence-number font-semibold">' +
              '<span class="licence-symbol">' +
              '<i class="fa fa-hashtag"></i>' +
              '</span>' +
              '<span class="licence-text text-mono">' + Utils.pad(item.id, '0', 8) + '</span>' +
              '</span>';

            return ret;
          },
          width: '10%'
        },
         {
          key: 'offer',
          label: Utils.t('remoteMonitoring.list.title'),
           showPopup: false,
           activeFilter: '',
           activeSort: false,
           sortable: false,
           showTooltip: true,
          renderer: function (item) {


            if (item.rmStatus != null && item.rmStatus != 12) {
              return '<span class="licence-type-45"><i class="option-label fa fa-bullhorn" title="' + Utils.t('device.registrations.licenceOption') + ' télésurveilleur' + '"></i></span>';
            }

          },
          width: '10%'
        },
        {
          key: 'profile.name',
          label: Utils.t('device.registrations.profile'),
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: true,
          filter: {
            type: 'text'
          },
          renderer: ProfileRenderer,
          width: '15%'
        },
        {
          key: 'groupId',
          label: Utils.t('device.groupSelect'),
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: false,
          width: '10%',
          filter: {
            type: 'list',
            values: []
          },
          renderer: function (item) {
            if (item.group != null) {
              return item.group.name;
            }
            return '';

          }
        },
        {
          key: 'status',
          label: Utils.t('device.registrations.state'),
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: false,
          showTooltip: true,
          tooltipTitle: Utils.t('device.tooltip.state.title'),
          tooltipContent: Utils.t('device.tooltip.state.content'),
          // filter: {
          //   type: 'list',
          //   values: [
          //     {
          //       id: 0,
          //       label: Utils.t('device.registrations.states.0')
          //     },
          //     {
          //       id: 1,
          //       label: Utils.t('device.registrations.states.1')
          //     },
          //     {
          //       id: 2,
          //       label: Utils.t('device.registrations.states.2')
          //     },
          //     {
          //       id: 3,
          //       label: Utils.t('device.registrations.states.3')
          //     }
          //   ]
          // },
          renderer: StatusRenderer,
          width: '7%'
        },
        {
          key: 'name',
          label: Utils.t('device.registrations.invitation'),
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: true,
          filter: {
            type: 'text'
          },
          renderer: InfoRenderer,
          width: '15%'
        },
        {
          key: 'rmStatus',
          label: '<i class="fa fa-bullhorn"></i>',
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: true,
          width: '6%',
          hide: true,
          filter: {
            label: Utils.t('device.remoteMonitoring'),
            type: 'text'
          },
          className: 'center-align',
          renderer: function (item) {
            if (item.rmStatus != null && item.rmStatus != 12) {
              switch (parseInt(item.rmStatus)) {
                case 1:
                  return '<i class="rm-status-icon fa fa-minus rm-status1" title="' + Utils.t('remoteMonitoring.status.status' + item.rmStatus) + '"></i>';
                  break;
                case 2:
                case 3:
                  return '<i class="rm-status-icon fa fa-exclamation-circle rm-status2" title="' + Utils.t('remoteMonitoring.status.status' + item.rmStatus) + '"></i>';
                  break;
                case 4:
                  return '<i class="rm-status-icon fa fa-check-circle rm-status4" title="' + Utils.t('remoteMonitoring.status.status' + item.rmStatus) + '"></i>';
                  break;
              }
            }
            return 'N/A';
          }

        },
        {
          key: 'id',
          label: '',
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: false,
          filter: false,
          renderer: ActionsRenderer,
          width: '10%'
        }

      ],
      rowActions: {}
    },
    // Status: 0:pas d'invit, 1: Invit en cours, 2: Invit validée, 3: Invit expirée
    tableData: [],
    lockDLBtn: false,
    showActionsDL: false,
    selectedItems: [],
    selectedReport: null,
    selectedReportOutput: 'html',
    overallSendableCount: 0,
    overallCancelableCount: 0,
    overallResendableCount: 0,
    isDrawerOpen: false,
    checkDevices: false
  }),

  created() {
    window.instance = this;
  },
  mounted() {
    if (!useDvFlagAccess("beepiz-licence-unassociated-can:read")) {
      this.$router.push({ name: 'AccessDenied', params: { slug: 'licences'} })
    } else {
        if (!Utils.can('beepiz-bulk-licences')) {
        this.forceFormDisabled = true;
      }
      this.loadData();
      this.loadGroupsAndProfiles();
      if (this.hasAnalytic) {
        let that = this;
        this.tableColumns.columns.splice(7, 0, {
          key: 'analyticCode',
          label: Utils.t('device.registrations.analyticCode'),
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: false,
          filter: false,
          width: '10%',
          showTooltip: true,
          tooltipTitle: Utils.t('device.tooltip.analyticCode.title'),
          tooltipContent: Utils.t('device.tooltip.analyticCode.content'),
          renderer: AnalyticsRenderer,
        });
      }
      window.Vfc.$refs.loading.hide();
    }
  },
  computed: {
    selectedReportOutputs: function () {
      return ['xls'];
    },
    hasAnalytic: function () {
      return window.V.clientInfos.beepiz_analytic_code
    },
    hasEmailLicenceFeature() {
      return useDvFlagAccess('beepiz-email-license-can:read');
    },
    getAvailableLicences: function () {
      var ret = 0;
      for (var lic in this.availableLicences) {
        ret += this.availableLicences[lic].nbDispoWithoutOption;

        if (Object.keys(this.availableLicences[lic].options).length > 0) {
          for (var opt in this.availableLicences[lic].options) {
            ret += this.availableLicences[lic].options[opt].nbDispo;
          }
        }
      }
      return ret - this.phones.length;
    },
    isMultiLicenceTypes: function () {
      if (Object.keys(this.availableLicences).length > 1) {
        return true;
      }
      return false;
    },
    // Status : 0 => Disponible, 1 => Envoyé, 2 => Enregistré, 3 => Expiré
    sendableCount: function() {
      if (this.selectedItems.length > 0) {
        // TODO : fix filter with status when possible
        return this.selectedItems.filter(item => item.status === 0).length;
      }
      return this.overallSendableCount;
    },
    cancelableCount: function() {
      if (this.selectedItems.length > 0) {
        // TODO : fix filter with status when possible
        return this.selectedItems.filter(item => item.status === 1 || item.status === 3).length;
      }
      return this.overallCancelableCount;
    },
    resendableCount: function() {
      if (this.selectedItems.length > 0) {
        // TODO : fix filter with status when possible
        return this.selectedItems.filter(item => item.status === 3).length;
      }
      return this.overallResendableCount;
    }
  },


  methods: {
    loadGroupsAndProfiles() {

      axios.get(API.endpoints.profiles.index + '?perpage=99999')
        .then(responseProfiles => {
          this.profiles = responseProfiles.data.data

          axios.get(API.endpoints.groups.index + '?perpage=99999')
            .then(responseGroups => {
              this.groups = responseGroups.data.data
              this.stickGroups();
              window.Vfc.$refs.loading.hide();
            })

        })
    },
    refreshSelection: function () {
      this.userAction += 1;
      window.instance = this;

      let position_group = document.getElementById('position_group');
      let batch_action_trigger = document.getElementById('batch-action-trigger');

      if (position_group !== undefined && position_group !== null && batch_action_trigger !== undefined && batch_action_trigger !== null) {
        var bodyRect = document.body.getBoundingClientRect(),
          elemRect = document.getElementById('position_group').getBoundingClientRect(),
          offsetY = (elemRect.top - bodyRect.top) - 35,
          offsetX = (elemRect.left - bodyRect.left) - (125);

        document.getElementById('batch-action-trigger').style.left = offsetX + "px";
        document.getElementById('batch-action-trigger').style.top = offsetY + "px";

      }
      window.setTimeout(function () {
        let count = 0;
        for (let i = 0; i < window.instance.tableData.length; i++) {
          count += (window.instance.tableData[i].selected === true) ? 1 : 0;
        }
        window.instance.userSelection = count;
      }, 250);
    },
    editAnalytics(record) {
      this.analyticsInEdition = record;
    },
    handlePagination: function (page) {
      this.config.page = page;
      this.loading = true;
      this.loadData();
    },
    handleSort: function () {
      this.config.sort = [];
      for (var colKey in this.tableColumns.columns) {
        var col = this.tableColumns.columns[colKey];
        if (col.activeSort) {
          this.config.sort.push(col.activeSort + col.key);
        }
      }
      this.loading = true;
      this.loadData();
    },
    handleFilter: function () {
      this.config.filter.like = [];
      this.config.filter.equals = [];
      for (var colKey in this.tableColumns.columns) {
        var col = this.tableColumns.columns[colKey];
        if (col.activeFilter != '') {
          if (col.filter && col.filter.type == 'text') {
            this.config.filter.like.push(col.key + ':' + col.activeFilter);
          }
          if (col.filter && col.filter.type == 'list') {
            this.config.filter.equals.push(col.key + ':' + col.activeFilter);
          }
        }
      }
      this.loading = true;
      this.loadData();
    },
    handleExpired: function (item) {
      if (item.registration.recipient) {
        item.status = 3;
      } else {
        item.status = 0;
      }
    },
    handleAssociation: function (item) {
      if (this.getAvailableLicences > 0 || item.status > 0) {
        // Use new modal if feature flag is enabled, otherwise use old Association
        const modalComponent = this.hasEmailLicenceFeature ? LicenceAssociationModal : Association;
        
        window.Vfc.modalProps = {
          title: Utils.t('device.titles.modalRegistration'),
          width: '450px',
          resetContent: true
        };
        window.Vfc.modalComponentProps = {
          dati: item,
          availableLicences: this.availableLicences,
          profiles: this.profiles,
          groups: this.groups
        };
        window.Vfc.modalComponent = modalComponent;
        window.Vfc.blurMode(true);
        window.Vfc.$refs.modal.show(() => {
          this.loadData();
        });
      } else {
        window.Vfc.$refs.messages.sendMessage('error', Utils.t('device.registrations.licenseNumberError'));
      }
    },
    handleCancel: function (item) {
      window.Vfc.$refs.confirm.show({
        title: Utils.t('device.registrations.actions.cancel.modalTitle'),
        content: Utils.t('device.registrations.actions.cancel.modalContent'),
        callbackYes: () => {
          axios.delete(API.route(API.endpoints.licences.delete, {hash: item.registration.hash}))
            .then(response => {
              this.loadData();

            }).catch(error => {
            this.loadData();
          })
        }
      });
    },
    handleSend: function (item) {
      axios.post(API.route(API.endpoints.licences.resend, {hash: item.registration.hash}), {datiId: item.id})
        .then(response => {
          this.loadData();
        }).catch(error => {
      })
    },
    handleSendFirstTime: function (item) {
      window.Vfc.modalProps = {
        title: Utils.t('device.registrations.actions.send.modalTitle'),
        width: '500px'
      };
      window.Vfc.modalComponentProps = {
        dati: item,
        profiles: this.profiles,
        groups: this.groups
      };
      window.Vfc.modalComponent = Sms;
      window.Vfc.blurMode(true);
      window.Vfc.$refs.modal.show(() => {
        // Closing callback:
        window.Vfc.modalComponent = null;
        this.loadData();
      });
    },
    phoneAlreadyExists(phone) {
      for (var pKey in this.phones) {
        if (this.phones[pKey].phonenumberV == phone) {
          return true;
        }
      }
      return false;
    },
    stickGroups: function () {

      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].selected = false;
        this.tableData[i].instance = this;
        this.tableData[i].groups = this.groups;
        this.tableData[i].hasEmailLicenceFeature = this.hasEmailLicenceFeature;

        if (this.tableData[i].groupId !== null) {

          for (let j = 0; j < this.groups.length; j++) {
            if (this.groups[j].id === this.tableData[i].group.name) {
              this.tableData[i].group = this.groups[j]['id'];
            }
          }
        } else {
          this.tableData[i].group = null;
        }
      }
    },
    getRegistrations() {
      this.inProgress = true
      let vm = this
      let isStarted = false
      let countOfBatches = 0
      let endOfDeadline = 0
      let maxProgressValue = 0
      const even = (element) => element.queue_registration_status == true;

      this.loadData()

      const checkStartedProcedure = setInterval(function () {
        let countInThisInterval = vm.tableData.filter(x => x.queue_registration_status == true).length

        if (countOfBatches < countInThisInterval) {
          countOfBatches = countInThisInterval
        } else {
          maxProgressValue = countOfBatches;
        }

        vm.progressBar = ((maxProgressValue - countInThisInterval) / maxProgressValue) * 100

        vm.loadData()
        endOfDeadline++

        if (vm.tableData.some(even) == true) {
          isStarted = true
        } else if (isStarted && vm.tableData.some(even) == false) {
          isStarted = false
          vm.progressBar = 100
          clearInterval(checkStartedProcedure)
          let subVm = vm
          setTimeout(function() { subVm.inProgress = false; }, 2000);
        }
        if (endOfDeadline == 14 && countOfBatches == countInThisInterval) {
          vm.errorSQS = true
          clearInterval(checkStartedProcedure)
          vm.inProgress = false
        }
      }, 1000)

    },
    handleCheckDevices: function () {
      this.checkDevices = !this.checkDevices;
      this.loading = true;
      this.loadData();
    },
    loadData: function () {
      axios.get(API.endpoints.licences.index + API.constructQueryParams(this.config) + '&devices=' + (this.checkDevices ? 1 : 0))
        .then(response => {
          this.tableData = this.transformList(response.data.data);
          this.refreshSelection();
          this.userSelection = 0;
          this.availableLicences = response.data.meta.availableLicences;
          this.count = response.data.meta.pagination.total;
          this.$refs.pagination.update(response.data.meta.pagination);

          // TODO : Fill with pagniation meta when possible
          this.overallSendableCount = response.data.meta.totalLicenceAvailable;
          this.overallCancelableCount = response.data.meta.totalLicenceExpired + response.data.meta.totalLicencePending;
          this.overallResendableCount = response.data.meta.totalLicenceExpired;

          if (!this.isMultiLicenceTypes) {
            for (var lKey in this.availableLicences) {
              if (this.availableLicences[lKey].options[235] == null) {
                this.bulkLicenceType = lKey
              }
            }

          }

          this.tableColumns.columns[4].filter.values = [];
          for (var groupKey in response.data.meta.filters.group) {
            this.tableColumns.columns[4].filter.values.push({
              id: groupKey,
              label: response.data.meta.filters.group[groupKey]
            })
          }

          for (var lKey in this.availableLicences) {
            if (this.availableLicences[lKey].options[235] != null) {
              //this.hasRemoteMonitoringLicence = true;

              this.tableColumns.columns[5].hide = false;
            }
          }
          this.loading = false
        })

    },
    transformList: function (list) {
      for (var i = 0; i < list.length; i++) {
        list[i].spRowClassname = 'status-{status}';
        list[i].hasEmailLicenceFeature = this.hasEmailLicenceFeature;

        const selectedItem = this.selectedItems.find(item => item.id === list[i].id);
        list[i].selected = !!selectedItem;

        if (selectedItem && list[i].status !== selectedItem.status) {
          selectedItem.status = list[i].status;
        }
      }
      return list;
    },
    validForm: function () {
      var tabPhones = [];
      for (var i = 0; i < this.phones.length; i++) {
        tabPhones.push(this.phones[i].phonenumber);
      }
      var objToSend = {
        recipients: tabPhones,
        datiName: this.phonesNames,
        analyticCode: this.phonesAnalytic,
        type_registration: "sms"
      }

      if (this.bulkLicenceType.indexOf('-') != -1) {
        var temp = this.bulkLicenceType.split('-');
        objToSend.offer = temp[0];
        objToSend.option = temp[1];
      }


      axios.post(API.endpoints.licences.add, objToSend)
        .then(response => {
          this.phones = [];
          this.phonesOptions = [];
          this.phonesNames = []
          this.phonesAnalytic = []
          this.$refs.csvFile.value = ""
          this.loadData();
        }).catch(error => {
        if (error.response.status == 422) {
          window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('errors.e422') + ' ' + error.response.data.message);
        }
      })
    },
    licencesExport: function (outputFormat) {
      if (!this.lockDLBtn) {
        this.$refs.loading.show();
        this.lockDLBtn = true;

        var route = API.endpoints.datis.licencesExport;
        var outputFormat = 'xls'
        var apiRoute = route;

        axios({
          method: 'post',
          url: apiRoute,
          responseType: 'blob',
          headers: {
            'Accept': Utils.getMimeFromOutput(outputFormat)
          }
        })
          .then(response => {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response.data], {type: Utils.getMimeFromOutput(outputFormat)})

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob, Utils.t('device.registrations.export_filename', { brand: Utils.getApplicationNameNormalized() }) + "." + outputFormat);
              return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = data;
            link.download = Utils.t('device.registrations.export_filename', { brand: Utils.getApplicationNameNormalized() });
            link.click();
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data);
            }, 100)
            this.$refs.loading.hide();
            this.lockDLBtn = false;

          })
          .catch(error => {
            this.$refs.loading.hide();
            this.lockDLBtn = false;

            if (error.response) {
              if (error.response.status == 422) {
                window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('errors.e422') + ' ' + error.response.data.message);
              }
            } else {
              window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('errors.e500') + ' ' + error);
            }
          })
      }
    },
    closeActionsDL: function () {
      if (this.showActionsDL && !this.dlFirstTime) {
        this.showActionsDL = false;
        this.dlFirstTime = true;
      } else {
        this.dlFirstTime = false;
      }
    },
    toggleActionsDL: function () {
      this.showActionsDL = !this.showActionsDL;
    },
    toggleDrawer: function () {
      this.isDrawerOpen = !this.isDrawerOpen;
      this.errorSQS = false;
    },
    handleSelectAll: function(selectAll) {
      for (let itemIdx in this.tableData) {
        this.tableData[itemIdx].selected = selectAll;
        this.handleSelectItem(this.tableData[itemIdx])
      }
    },
    handleSelectItem: function(item) {
      const itemIdx = this.selectedItems.findIndex((currentItem) => item.id === currentItem.id)

      if (itemIdx === -1 && item.selected) {
        this.selectedItems.push({id: item.id, status: item.status})
      } else if ((itemIdx !== -1 && !item.selected)) {
        this.selectedItems.splice(itemIdx, 1)
      }
    },
    handleCancelLicences: function() {
      window.Vfc.$refs.confirm.show({
        title: Utils.t("device.registrations.cancel_licences.title"),
        content: null,
        content_component: ActionsLicencesModal,
        content_component_props: {
          itemCount: this.cancelableCount,
          type: 'cancel',
          selectedLicences: this.selectedItems
        },
        // content: Utils.tc("device.registrations.cancel_licences.info", this.cancelableCount, {count: this.cancelableCount}),
        callbackYes: () => {
          this.loading = true;
          axios.post(API.endpoints.licences.mass.cancel, {list_licence: this.selectedItems.map(item => item.id) })
            .then(() => {
              window.Vfc.$refs.messages.sendMessage('success', window.V.$i18n.t('device.registrations.cancel_licences.success'));
              this.loading = true;
              this.loadData()
            })
            .catch(error => {
              if (Utils.isThemeSfr()) {
                window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('device.registrations.cancel_licences.error_sfr'));
              } else if (Utils.isThemeCatsafe()) {
                window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('device.registrations.cancel_licences.error_catsafe'));
              } else {
                window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('device.registrations.cancel_licences.error'));
              }
            })
        },
        yesButtonText: Utils.tc("global.confirm"),
        noButtonText: Utils.tc("global.close"),
      });
    },
    handleResendLicences: function() {
      window.Vfc.$refs.confirm.show({
        title: Utils.t("device.registrations.resend_licences.title"),
        content: null,
        content_component: ActionsLicencesModal,
        content_component_props: {
          itemCount: this.resendableCount,
          type: 'resend',
          selectedLicences: this.selectedItems
        },
        callbackYes: () => {
          this.loading = true;
          axios.post(API.endpoints.licences.mass.resend, {list_licence: this.selectedItems.map(item => item.id) })
            .then(() => {
              window.Vfc.$refs.messages.sendMessage('success', window.V.$i18n.t('device.registrations.resend_licences.success'));
              this.loading = true;
              this.loadData()
            })
            .catch(error => {
              if (Utils.isThemeSfr()) {
                window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('device.registrations.resend_licences.error_sfr'));
              } else if (Utils.isThemeCatsafe()) {
                window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('device.registrations.resend_licences.error_catsafe'));
              } else {
                window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('device.registrations.resend_licences.error'));
              }
            })
        },
        yesButtonText: Utils.tc("global.confirm"),
        noButtonText: Utils.tc("global.close"),
      });
    }

  },
  mixins: [
    denseModeMixin,
    clickaway
  ],
  watch: {},

  beforeRouteLeave(to, from, next) {
    window.Vfc.blurMode(false);
    window.Vfc.$refs.modal.hide();
    next();
  }
}

</script>

<style lang="scss">
.progress-table {
  position: absolute;
  z-index: 1;
  border-radius: 0;
  opacity: 1;
  background: #ffffff50;
  height: 8px;
  width: 100%;
}
</style>


